export type QueryParameters = {
  startTime: string;
  endTime: string;
  timeFrame: string;
  category: string;
  fileTypeIdFilters: string;
  excludeFileTypeIdFilters: string;
  vimsData: string;
  dealerCode?: string;
  reportType: string;
  vimsTransaction?: string;
  viewFileSize: string;
};

export const QueryParameterKeys: QueryParameters = {
  startTime: 'startTime',
  endTime: 'endTime',
  timeFrame: 'timeFrame',
  category: 'category',
  fileTypeIdFilters: 'fileTypeIdFilters',
  excludeFileTypeIdFilters: 'excludeFileTypeIdFilters',
  vimsData: 'vimsData',
  dealerCode: 'dealerCode',
  reportType: 'reportType',
  vimsTransaction: 'vimsTransaction',
  viewFileSize: 'viewFileSize'
};
